import { useSelectTypeOfFilter } from '@aibees/elephant/feature/search-list-card/hooks/use-select-type-of-filter';
import { ROUTES as R } from '@aibees/elephant/router';
import { LabelGrouping, LabelType } from '@aibees/elephant/types/label';
import { IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils/class-names';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { createListSearchActionMenuItems } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import { type ListSearchTableActionProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;

export const ListSearchTableAction = memo(({ className, item }: Props) => {
  const { handleSelect, isLabelAlreadyInParams } = useSelectTypeOfFilter(
    LabelType.LIST,
    item
  );

  const menuItems = createListSearchActionMenuItems(isLabelAlreadyInParams);

  const handleViewClick = () => {
    const listId = encodeURIComponent(item.id);
    const param = encodeURIComponent(`${item.name}::${listId}`);

    if (item.grouping === LabelGrouping.COMPANY) {
      const url = `${R.searchCompany}?companies_include_list=${param}`;
      window.open(url, '_blank');
    } else if (item.grouping === LabelGrouping.PEOPLE) {
      const url = `${R.searchPeople}?people_include_list=${param}`;
      window.open(url, '_blank');
    }
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap={0.5}
    >
      <IconButton
        icon="eye-outlined"
        variant="outlined"
        size="xsmall"
        onClick={handleViewClick}
      />
      <Styled.Wrapper
        className={classnames('ListSearchTableAction', className)}
        popoverSx={SX.popover}
        icon="more-horizontal"
        variant="outlined"
        size="xsmall"
        items={menuItems}
        itemSx={SX.item}
        itemDivider={true}
        onSelect={handleSelect}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      />
    </Stack>
  );
});

ListSearchTableAction.displayName = 'ListSearchTableAction';
